<div class="container-fluid">
	<div class="row align-items-center mx-0">
		<div class="col">
			<h1 class="my-3 text-capitalize">Pharos Credentials</h1>
		</div>
		<div class="col-auto px-0 text-end">
			<button type="button" class="ml-2 btn btn-secondary" [routerLink]="['/add-pharos-credentials']"> Agregar Pharos Credential</button>
		</div>
	</div>

	<div>
		<div class="row">
			<div class="col-6 col-md-3 form-group">
				<label class="">Nombre</label>
				<input type="text" name="name" [(ngModel)]="pharos_credentials_search.lk.name" class="form-control">
			</div>
			<div class="col-6 col-md-3 form-group">
				<label class="">Usuario</label>
				<input type="text" name="user" [(ngModel)]="pharos_credentials_search.lk.user" class="form-control">
			</div>
			<div class="col-6 col-md-3 form-group">
				<label class="">Merchant Code</label>
				<input type="text" name="merchant_code" [(ngModel)]="pharos_credentials_search.lk.merchant_code" class="form-control">
			</div>
			<div class="col-6 col-md-3 form-group">
				<label class="">Terminal Code</label>
				<input type="text" name="terminal_code" [(ngModel)]="pharos_credentials_search.lk.terminal_code" class="form-control">
			</div>
			<div class="col-6 col-md-3">
				<label>&nbsp;</label>
				<div>
					<button type="button" class="w-100 btn btn-primary" (click)="search()">Buscar</button>
				</div>
			</div>
		</div>
	</div>

	<div class="card p-3 mt-3">
		<app-loading [is_loading]="is_loading"></app-loading>
		<div class="table-responsive">
			<table class="table table-sm table-nowrap mb-0">
				<thead class="thead-light">
					<tr>
						<th>Nombre</th>
						<th>Usuario</th>
						<th>Merchant Code</th>
						<th>Terminal Code</th>
						<th>Endpoint</th>
						<th>Actualizacíon</th>
					</tr>
				</thead>
				<tbody>
					<tr *ngFor="let credential of pharos_credentials_list">
						<td>
							<a [routerLink]="['/edit-pharos-credentials',credential.id]">{{credential.name}}</a>
						</td>
						<td>{{credential.user}}</td>
						<td>{{credential.merchant_code}}</td>
						<td>{{credential.terminal_code}}</td>
						<td>{{credential.endpoint}}</td>
						<td>{{credential.updated | shortDate: 'relative' }}</td>
					</tr>
					<tr *ngIf="pharos_credentials_list == null || pharos_credentials_list.length == 0 && !is_loading" colspan="TEMPLATE_HEADERS_SIZE">
						<div class="alert alert-light m-3" role="alert">No se encontraron elementos</div>
					</tr>
				</tbody>
			</table>
		</div>
	</div>
	<app-pagination [path]="'/list-pharos-credentials'" [pages]="pages" [total_pages]="total_pages" [current_page]="current_page"></app-pagination>
</div>
